import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      justifyContent: 'start'
    },
    label: {
      margin: 0,
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '17px',
      fontStyle: 'normal'
    },
    inputError: {
      margin: '0px 10px',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '17px',
      fontStyle: 'normal',
      color: palette.danger.red
    },
    input: {
      border: 'none',
      borderBottom: '1px solid black',
      outline: 'none',
      fontSize: '14px',
      color: palette.text.primary
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
